/**!
 * Created by Leonardo Cheslacki on 19/09/2024.
 *
 * MIT License
 *
 * Copyright (c) 2024 cheslacki
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.

 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */

import PropTypes from 'prop-types';

import StageController from './StageController';

import WithType from './../helpers/WithType';

let _this = {};

/**
 *
 */
class StageQuizVertical extends StageController {

    /**
     *
     * @param props
     * @param main
     */
    constructor(props, main = {}) {
        super(props);
        this.props = props;
        this.main = main;

        this.state = {
            data: [],
            next: false
        };

        this.$current_frame = 1;

        this.$current_sub_frame = 1;

        this.$formRadio = this.main.$formRadio();

        _this = this;
    };

    $functions = {
        /**
         *
         * @param event
         * @param object
         */
        handleNext: function (event, object) {
            const
                _this_frame = _this.getFrame(),
                _this_sub_frame = _this.verifyField(object, '_this_sub_frame');

            if (_this_sub_frame) {
                const
                    {totalFrames} = _this_frame,
                    total_frames = (totalFrames - 1),
                    callback = _this.verifyField(object, 'callback'),
                    response = _this.verifyField(object, 'response');

                const next = () => {
                    _this.$current_sub_frame++;

                    callback(response);

                    if (_this.$current_sub_frame >= total_frames) {
                        _this.setState({..._this.state, next: true}, () => {
                            let
                                back = _this.verifyField(object, 'back'),
                                {data} = _this.state,
                                {response} = data.find(({quiz}) => (quiz === 1));

                            back && (_this.$current_frame = back);
                            response && (_this.$current_sub_frame = response);
                        });
                    }

                    _this_sub_frame.gotoAndPlay('complete');
                };

                _this.$formRadio.setFocus(response);

                let btn_next = _this.verifyField(_this_sub_frame, 'btn_next');

                if (btn_next) {
                    _this._handleNext && btn_next.off('mousedown', _this._handleNext);
                    _this._handleNext = btn_next.on('mousedown', () => {
                        if (_this.$formRadio.isFocus()) {
                            _this.$formRadio.clearFocus();
                            next();
                        }
                    });
                } else {
                    next();
                }
            } else {
                const
                    {next} = _this.state,
                    {totalFrames} = _this.get(),
                    increment = _this.verifyField(object, 'increment'),
                    total_frames = (totalFrames - 1);

                if (next) {
                    _this.$current_frame++;
                } else if (_this.$current_frame >= total_frames) {
                    _this.$current_frame = 1;
                }

                if (increment) {
                    _this.$current_frame = (_this.$current_frame + increment);
                }

                _this_frame.gotoAndPlay('complete');
            }
        },

        /**
         *
         * @param event
         * @param object
         */
        handleBack: function (event, object) {
            const _this_sub_frame = _this.verifyField(object, '_this_sub_frame');

            _this_sub_frame && _this_sub_frame.gotoAndPlay('complete');
        }
    };

    startQuiz = () => {
        const {delay, time} = this.props;

        /**
         * On of emit current_name index, correspond all animate_end.
         */
        this.main.on('animate_end', ({current_name}) => {

            this.gotoAndStopFrame(this.get(), this.$current_frame);

            const
                _this_frame = this.getFrame(),
                occ = this.padWithLeadingZeros(this.$current_frame, 2);

            if (this.inArray(['01', '02'], occ)) {
                _this_frame.gotoAndPlay('start');
            }

            if (occ === '02') {
                const {btn_frame03, btn_frame04} = _this_frame;

                this._handleFrame03 && btn_frame03.off('mousedown', this._handleFrame03);
                this._handleFrame03 = btn_frame03.on('mousedown', this.$functions.handleNext, false, false, {increment: 0});

                this._handleFrame04 && btn_frame04.off('mousedown', this._handleFrame04);
                this._handleFrame04 = btn_frame04.on('mousedown', this.$functions.handleNext, false, false, {increment: 1});

            } else if (this.inArray(['03', '04'], occ)) {
                this.gotoAndStopFrame(_this_frame, this.$current_sub_frame);

                let _this_sub_frame = this.getFrame(_this_frame, true);

                _this_sub_frame.gotoAndPlay('start');

                this.setState({...this.state, next: false}, () => {
                    let buttons = this.verifyField(_this_sub_frame, 'occ_button.children');

                    this.$formRadio.setRadios(_this_sub_frame);

                    if (this.isArrayIf(buttons)) {
                        let length = buttons.length;

                        for (let i = 0; i < length; i++) {
                            let
                                button = buttons[i],
                                name = button.name,
                                className = this.toClassName(name);

                            this.$formRadio.initFocus(i);

                            this[`_handle${className}`] && button.off('mousedown', this[`_handle${className}`]);
                            this[`_handle${className}`] = button.on('mousedown', this.$functions.handleNext, false, false, {
                                _this_sub_frame: _this_sub_frame,
                                back: this.hasString(name, 'back') ? this.toNumber(name) : null,
                                response: (i + 1),
                                callback: (response) => {
                                    if (response) {
                                        this.setState({
                                            ...this.state,
                                            data: [
                                                ...this.state.data,
                                                {
                                                    quiz: (this.$current_sub_frame - 1),
                                                    response: response
                                                }
                                            ]
                                        });
                                    }
                                }
                            });
                        }
                    }
                });
            } else if (this.inArray(['05', '06'], occ)) {
                this.gotoAndStopFrame(_this_frame, this.$current_sub_frame);

                let _this_sub_frame = this.getFrame(_this_frame, true);

                _this_sub_frame.gotoAndPlay('start');

                this.$current_frame = 1;

                this.$current_sub_frame = 1;

                this.setState({...this.state, next: true, data: []}, () => {
                    let {btn_back} = _this_sub_frame;

                    this._handleBack && btn_back.off('mousedown', this._handleBack);
                    this._handleBack = btn_back.on('mousedown', this.$functions.handleBack, false, false, {
                        _this_sub_frame: _this_sub_frame
                    });
                });
            }
        });
    };

    /**
     *
     */
    initQuiz = () => {
        const {btn_frame02} = this.getFrame();

        this._handleFrame02 && btn_frame02.off('mousedown', this._handleFrame02);
        this._handleFrame02 = btn_frame02.on('mousedown', this.$functions.handleNext);

        this.setState({...this.state, next: true}, this.startQuiz);
    };
}

/**
 *
 * @type {{}}
 */
StageQuizVertical.propTypes = {
    delay: PropTypes.number,
    time: PropTypes.number
};

/**
 *
 * @type {{}}
 */
StageQuizVertical.defaultProps = {
    delay: 1000,
    time: 5
};

/**
 *
 * @param ClassObject
 * @param className {className: 'className'}
 * @returns {function(*): function({}=): *} pass _this ClassMain (required) and props {} (optional)
 */
export default WithType(StageQuizVertical, {className: 'StageQuizVertical'});
